export default [
  {
    path: "/mahasiswa/ganti-password",
    name: "mahasiswa-ganti-password",
    component: () => import("../../views/mahasiswa/profil/GantiPassword.vue"),
    meta: {
      pageTitle: "Ganti Password",
    },
  },

  /**
   *  KURIKULUM
   */
  {
    path: "/mahasiswa/kurikulum",
    name: "mahasiswa-kurikulum",
    component: () =>
      import("../../views/mahasiswa/kurikulum/ListMatakuliahKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  /**
   *  AKTIVITAS
   */

  {
    path: "/mahasiswa/aktivitas",
    name: "mahasiswa-aktivitas",
    component: () => import("../../views/mahasiswa/aktivitas/Aktivitas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Aktivitas", active: true },
      ],
      pageTitle: "Aktivitas",
    },
  },
  {
    path: "/mahasiswa/aktivitas/aktivitas-perkuliahan",
    name: "mahasiswa-aktivitas-perkuliahan",
    component: () =>
      import("../../views/mahasiswa/aktivitas/AktivitasPerkuliahan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Aktivitas", url: "/mahasiswa/aktivitas" },
        { title: "Aktivitas Perkuliahan", active: true },
      ],
      pageTitle: "Aktivitas Perkuliahan",
    },
  },
  /**
   *  NILAI
   */

  {
    path: "/mahasiswa/nilai",
    name: "mahasiswa-nilai",
    component: () => import("../../views/mahasiswa/nilai/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Nilai", active: true },
      ],
      pageTitle: "Nilai",
    },
  },

  // // nilai uts/uas
  // {
  //   path: "/mahasiswa/report-nilai-mahasiswa/:urlEncoded",
  //   name: "mahasiswa-report-nilai-mahasiswa",
  //   component: () =>
  //     import("../../views/mahasiswa/nilai/ReportNilaiMahasiswa.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       { title: "Nilai", url: "/mahasiswa/nilai" },
  //       { title: "Report Nilai Mahasiswa", active: true },
  //     ],
  //     pageTitle: "Report Nilai Mahasiswa",
  //   },
  // },
  // // nilai per semester
  // {
  //   path: "/mahasiswa/report-nilai-semester/:urlEncoded",
  //   name: "mahasiswa-report-nilai-semester",
  //   component: () =>
  //     import("../../views/mahasiswa/nilai/ReportNilaiSemester.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       { title: "Nilai", url: "/mahasiswa/nilai" },
  //       { title: "Report Nilai Semester", active: true },
  //     ],
  //     pageTitle: "Report Nilai Semester",
  //   },
  // },

  // nilai keseluruhan
  // {
  //   path: "/mahasiswa/report-nilai-keseluruhan/:urlEncoded",
  //   name: "mahasiswa-report-nilai-keseluruhan",
  //   component: () =>
  //     import("../../views/mahasiswa/nilai/ReportNilaiKeseluruhan.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       { title: "Nilai", url: "/mahasiswa/nilai" },
  //       { title: "Report Nilai Keseluruhan", active: true },
  //     ],
  //     pageTitle: "Report Nilai Keseluruhan",
  //   },
  // },

  /**
   *  KRS
   */
  {
    path: "/mahasiswa/krs",
    name: "mahasiswa-krs",
    component: () => import("../../views/mahasiswa/krs/Krs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kartu Rencana Studi", active: true },
      ],
      pageTitle: "Kartu Rencana Studi",
    },
  },

  {
    path: "/mahasiswa/krs/tambah-krs",
    name: "mahasiswa-tambah-krs",
    component: () => import("../../views/mahasiswa/krs/TambahKrs.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },

        { title: "Kartu Rencana Studi", url: "/mahasiswa/krs" },
        { title: "Tambah KRS", active: true },
      ],
      pageTitle: "Tambah KRS",
    },
  },

  /**
   *  PERWALIAN
   */
  {
    path: "/mahasiswa/perwalian/respon-perwalian",
    name: "mahasiswa-respon-perwalian",
    component: () =>
      import("../../views/mahasiswa/perwalian/ResponPerwalian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kartu Rencana Studi", url: "/mahasiswa/krs" },
        { title: "Perwalian", active: true },
      ],
      pageTitle: "Perwalian",
    },
  },

  /**
   *  KARTU & SERTIFIKAT
   */
  {
    path: "/mahasiswa/kartu-sertifikat",
    name: "mahasiswa-kartu-sertifikat",
    component: () =>
      import("../../views/mahasiswa/kartu-sertifikat/KartuSertifikat.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kartu & Serfitikat", active: true },
      ],
      pageTitle: "Kartu & Sertifikat",
    },
  },

  {
    path: "/mahasiswa/kartu-sertifikat/kartu-ujian",
    name: "mahasiswa-kartu-ujian",
    component: () =>
      import("../../views/mahasiswa/kartu-sertifikat/KartuUjian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        {
          title: "Kartu & Sertifikat",
          url: "/mahasiswa/kartu-sertifikat",
        },
        { title: "Kartu Ujian", active: true },
      ],
      pageTitle: "Kartu Ujian",
    },
  },

  // {
  //   path: "/mahasiswa/kartu-sertifikat/transkrip-nilai",
  //   name: "mahasiswa-transkrip-nilai",
  //   component: () =>
  //     import("../../views/mahasiswa/kartu-sertifikat/TranskripNilai.vue"),
  //   meta: {
  //     breadcrumb: [
  //       { title: "Home", url: "/apps" },
  //       {
  //         title: "Kartu & Sertifikat",
  //         url: "/mahasiswa/kartu-sertifikat",
  //       },
  //       { title: "Transkrip Nilai", active: true },
  //     ],
  //     pageTitle: "Transkrip Nilai",
  //   },
  // },
  {
    path: "/mahasiswa/kartu-sertifikat/sertifikat",
    name: "mahasiswa-sertifikat",
    component: () =>
      import("../../views/mahasiswa/kartu-sertifikat/Sertifikat.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        {
          title: "Kartu & Sertifikat",
          url: "/mahasiswa/kartu-sertifikat",
        },
        { title: "Sertifikat", active: true },
      ],
      pageTitle: "Sertifikat",
    },
  },

  {
    path: "/mahasiswa/kartu-presensi",
    name: "mahasiswa-kartu-presensi",
    component: () =>
      import("../../views/mahasiswa/kartu-sertifikat/KartuPresensi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        {
          title: "Kartu & Sertifikat",
          url: "/mahasiswa/kartu-sertifikat",
        },
        { title: "Kartu Presensi", active: true },
      ],
      pageTitle: "Kartu Presensi",
    },
  },
  {
    path: "/mahasiswa/kartu-studi-tetap",
    name: "mahasiswa-kst",
    component: () => import("../../views/mahasiswa/kartu-sertifikat/Kst.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        {
          title: "Kartu & Sertifikat",
          url: "/mahasiswa/kartu-sertifikat",
        },
        { title: "KST", active: true },
      ],
      pageTitle: "KST",
    },
  },

  /**
   *  ADMINISTRASI
   */
  {
    path: "/mahasiswa/administrasi",
    name: "mahasiswa-administrasi",
    component: () =>
      import("../../views/mahasiswa/administrasi/administrasi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Administrasi Keuangan", active: true },
      ],
      pageTitle: "Administrasi Keuangan",
    },
  },

  {
    path: "/mahasiswa/administrasi/ukt",
    name: "mahasiswa-adminstrasi-ukt",
    component: () => import("../../views/mahasiswa/administrasi/ukt.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Administrasi Keuangan", url: "/mahasiswa/administrasi" },

        { title: "UKT", active: true },
      ],
      pageTitle: "UKT",
    },
  },
  {
    path: "/mahasiswa/administrasi/bni",
    name: "mahasiswa-adminstrasi-bni",
    component: () => import("../../views/mahasiswa/administrasi/bni_2022.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Administrasi Keuangan", url: "/mahasiswa/administrasi" },

        { title: "BNI", active: true },
      ],
      pageTitle: "BNI",
    },
  },
  {
    path: "/mahasiswa/administrasi/mdr",
    name: "mahasiswa-adminstrasi-mdr",
    component: () => import("../../views/mahasiswa/administrasi/mdr_2022.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Administrasi Keuangan", url: "/mahasiswa/administrasi" },

        { title: "Mandiri", active: true },
      ],
      pageTitle: "Mandiri",
    },
  },

  /**
   *  TUGAS AKHIR
   */

  {
    path: "/mahasiswa/tugas-akhir",
    name: "mahasiswa-tugas-akhir",
    component: () => import("../../views/mahasiswa/tugasakhir/TugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tugas Akhir", active: true },
      ],
      pageTitle: "Tugas Akhir",
    },
  },

  {
    path: "/mahasiswa/tugas-akhir/tambah-tugas-akhir",
    name: "mahasiswa-tambah-tugas-akhir",
    component: () =>
      import("../../views/mahasiswa/tugasakhir/TambahTugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tugas Akhir", url: "/mahasiswa/tugas-akhir" },
        { title: "Tambah Tugas Akhir", active: true },
      ],
      pageTitle: "Tambah Tugas Akhir",
    },
  },
  {
    path: "/mahasiswa/tugas-akhir/seminar-proposal",
    name: "mahasiswa-seminar-proposal",
    component: () =>
      import("../../views/mahasiswa/tugasakhir/SeminarProposal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tugas Akhir", url: "/mahasiswa/tugas-akhir" },
        { title: "Seminar Proposal", active: true },
      ],
      pageTitle: "Seminar Proposal",
    },
  },

  {
    path: "/mahasiswa/tugas-akhir/seminar-kolokium",
    name: "mahasiswa-seminar-kolokium",
    component: () =>
      import("../../views/mahasiswa/tugasakhir/SeminarKolokium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tugas Akhir", url: "/mahasiswa/tugas-akhir" },
        { title: "Seminar Kolokium/Skripsi", active: true },
      ],
      pageTitle: "Seminar Kolokium/Skripsi",
    },
  },

  {
    path: "/mahasiswa/tugas-akhir/seminar-yudisium",
    name: "mahasiswa-seminar-yudisium",
    component: () =>
      import("../../views/mahasiswa/tugasakhir/SeminarYudisium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tugas Akhir", url: "/mahasiswa/tugas-akhir" },
        { title: "Seminar Yudisium", active: true },
      ],
      pageTitle: "Seminar Yudisium",
    },
  },

  /**
   *   PERPUSTAKAAN
   */
  {
    path: "/mahasiswa/perpustakaan",
    name: "mahasiswa-perpustakaan",
    component: () =>
      import("../../views/mahasiswa/perpustakaan/Perpustakaan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Perpustakaan", active: true },
      ],
      pageTitle: "Perpustakaan",
    },
  },
  {
    path: "/mahasiswa/perpustakaan/turnitin",
    name: "mahasiswa-perpustakaan-turnitin",
    component: () => import("../../views/mahasiswa/perpustakaan/Turnitin.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Perpustakaan", url: "/mahasiswa/perpustakaan" },
        { title: "Turintin", active: true },
      ],
      pageTitle: "Turintin",
    },
  },

  {
    path: "/mahasiswa/perpustakaan/tambah-berkas",
    name: "mahasiswa-perpustakaan-tambah-berkas",
    component: () =>
      import("../../views/mahasiswa/perpustakaan/TambahBerkas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Perpustakaan", url: "/mahasiswa/perpustakaan" },
        { title: "Turintin", url: "/mahasiswa/perpustakaan/turnitin" },
        { title: "Tambah Berkas", active: true },
      ],
      pageTitle: "Tambah Berkas",
    },
  },

  /**
   *   IA
   */
  {
    path: "/mahasiswa/ia",
    name: "mahasiswa-ia",
    component: () => import("../../views/mahasiswa/kerjasama/Ia.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "IA", active: true },
      ],
      pageTitle: "IA",
    },
  },
  {
    path: "/mahasiswa/ia/tambah-ia",
    name: "mahasiswa-ia-tambah-ia",
    component: () => import("../../views/mahasiswa/kerjasama/TambahIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "IA", url: "/mahasiswa/ia" },
        { title: "Tambah IA", active: true },
      ],
      pageTitle: "Tambah IA",
    },
  },
];
